import { createSlice } from "@reduxjs/toolkit";


const unOrganizedInventorySlice = createSlice({
    name: "unOrganizedInventory",
    initialState: {
        unOrganizedInventoryData: [],
        totalItems: [],
        itemsPerPage: 10,
        currentPage: 1
    },
    reducers: {
        setUnOrganizedInventoryData: (state, action) => {
            state.unOrganizedInventoryData = action.payload;
        },

        setTotalItems: (state, action) => {
            state.totalItems = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },


    }
});

export const {
    setUnOrganizedInventoryData,
    setTotalItems,
    setItemsPerPage,
    setCurrentPage
} = unOrganizedInventorySlice.actions;

export default unOrganizedInventorySlice.reducer;